export default {
  buttons: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    update: "Update",
    submit: "Submit",
    close: "Close",
    back: "Back",
    next: "Next",
    previous: "Previous",
    search: "Search",
    filter: "Filter",
    reset: "Reset",
    clear: "Clear",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    ok: "OK",
    apply: "Apply",
    export: "Export",
    import: "Import",
    download: "Download",
    upload: "Upload",
    view: "View",
    details: "Details",
    select: "Select",
    selectAll: "Select All",
    deselectAll: "Deselect All",
    refresh: "Refresh",
    loading: "Loading...",
    processing: "Processing...",
  },
  messages: {
    success: "Operation completed successfully",
    error: "An error occurred",
    warning: "Warning",
    info: "Information",
    confirmDelete: "Are you sure you want to delete this item?",
    confirmAction: "Are you sure you want to perform this action?",
    noData: "No data available",
    noResults: "No results found",
    loading: "Loading...",
    saving: "Saving...",
    saved: "Saved successfully",
    updated: "Updated successfully",
    deleted: "Deleted successfully",
    created: "Created successfully",
    errorOccurred: "An error occurred. Please try again.",
    networkError: "Network error. Please check your connection.",
    unauthorized: "You are not authorized to perform this action",
    forbidden: "Access forbidden",
    notFound: "Resource not found",
    serverError: "Server error. Please try again later.",
  },
  labels: {
    name: "Name",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    phone: "Phone",
    address: "Address",
    description: "Description",
    status: "Status",
    date: "Date",
    time: "Time",
    createdAt: "Created At",
    updatedAt: "Updated At",
    actions: "Actions",
    active: "Active",
    inactive: "Inactive",
    enabled: "Enabled",
    disabled: "Disabled",
    yes: "Yes",
    no: "No",
    all: "All",
    none: "None",
    select: "Select",
    search: "Search",
    filter: "Filter",
    sort: "Sort",
    page: "Page",
    of: "of",
    total: "Total",
    items: "Items",
    perPage: "Per Page",
    showing: "Showing",
    to: "to",
    results: "results",
  },
  placeholders: {
    search: "Search...",
    select: "Select an option...",
    enterText: "Enter text...",
    enterEmail: "Enter your email",
    enterPassword: "Enter your password",
    enterName: "Enter name",
    enterPhone: "Enter phone number",
    enterAddress: "Enter address",
    enterDescription: "Enter description...",
    noResults: "No results found",
  },
};
